import { Heading } from "@/components/ui/heading";
import { AppCollapsible } from "@components";
import { useAuth } from "@state/auth";
import { Show } from "solid-js";
import { useService } from "solid-services";
import { Divider, Grid } from "styled-system/jsx";
import Delete from "./Delete";
import Edit from "./Edit";
import Override from "./Override";

export default function () {
  const { isAdmin } = useService(useAuth)()

  return (
    <Grid height='100%' justifyContent='stretch' gridTemplateRows='1fr auto' w='100%'>

      <Show when={isAdmin()}>

        <AppCollapsible headerContent={<Heading textStyle='sm'>Override Next</Heading>} >
          <Override />
        </AppCollapsible>

        <AppCollapsible headerContent={<Heading textStyle='sm'>Edit</Heading>} >
          <Edit />
        </AppCollapsible>

        <AppCollapsible headerContent={<Heading textStyle='sm'>Delete</Heading>} >
          <Delete />
        </AppCollapsible>

        <Divider />
      </Show>
    </Grid>
  )
}
